const getters = {
  notes: (state) => state.notes,
  loading: (state) => state.loading,
  error: (state) => state.error,

  noteWindowWidth: (state) => state.noteWindowWidth,
  noteWindowHeight: (state) => state.noteWindowHeight,

  getNoteByProposalNumber: (state) => (proposalNumber) => {
    return state.notes.find((note) => note.proposalNumber === proposalNumber);
  },
};

export default getters;
